var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"}],on:{"click":_vm.click1}},[_vm._v("\n  "+_vm._s(_vm.label1)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }